module.exports = __webpack_public_path__ + "img/tb.3c847245.png";